import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "../../../css/page-profile.css";
import { useAuth } from "../../Context/store/context";
import globals from '../../../globals';
import { IconPlus, IconTrash } from '@tabler/icons-react';
import { _showToast } from "../../../toastHelper";
import { _delete, _get } from "../../../apiClient";
import AddDomain from "./AddDomain";
import { domainsList } from '../../Redux/Actions/DomainsListAction';


export default function MyDomains() {
  const domains = useSelector((state) => state.DomainsList.domainsList);
  const userDetails = useSelector((state) => state.admininfo.admininfo);

  const { showLoader, hideLoader, updateTitleAndIcon, getToken, logoutuser, fetchUserDetails } = useAuth();
  const dispatch = useDispatch();
  const [isInitialLoading, setInitialLoading] = useState(true);
  const [myDomains, setMyDomains] = useState([]);
  const [showAddDomain, setShowAddDomain] = useState(false);

  useEffect(() => {
    if (!getToken())
      logoutuser();
    updateTitleAndIcon(globals.domains.title, globals.domains.icon);
  }, []);

  useEffect(() => {
    if (userDetails && isInitialLoading && domains.length == 0) {
      fetchDomains();
    }
    else {
      setMyDomains(domains);
    }
  }, [domains, userDetails])


  const fetchDomains = async () => {
    showLoader();
    setInitialLoading(false);
    await _get('/app-user-domains')
      .then((response) => {
        dispatch(domainsList(response));
        hideLoader();
      })
      .catch((error) => {
        hideLoader();
        _showToast(error, "error");
      });
  }

  const handleAddDomain = () => {
    setShowAddDomain(true);
  };

  const closeAddHandler = () => {
    setShowAddDomain(false);
  }

  const deleteDomainHandler = async (id) => {
    const confirmation = window.confirm(
      "Are you sure you want to delete this? This action cannot be undone."
    );

    if (confirmation) {
      const result = await deleteDomain(id);
      if (result) {
        fetchUserDetails();
        fetchDomains();
      }
    }
  }


  const deleteDomain = async (id) => {
    showLoader();
    return await _delete('/app-user-domains/' + id)
      .then((response) => {
        return true;
      })
      .catch((error) => {
        hideLoader();
        _showToast(error, "error");
        return false;
      });
  }
  return (
    <>
      <div className="content-wrapper">
        <div className="container-xxl flex-grow-1 container-p-y">
          <div className="row">
            <div className="col-12 mb-4">
              {myDomains && myDomains.length == 0 && (
                <div className="mb-3">
                  <div className="d-flex flex-lg-row  justify-content-between align-items-md-center gap-1">
                    <div style={{ width: "375px" }}>
                    </div>
                    <div>
                      <button className="btn btn-primary px-2" onClick={handleAddDomain} >
                        <IconPlus size={20} className='me-1' />
                        <span className="align-middle">Add Domain</span>
                      </button>
                    </div>
                  </div>
                </div>
              )}
              <div className="card">
                <div className="card-datatable  pt-0">
                  <div id='example_wrapper' className='dataTables_wrapper dt-bootstrap5 no-footer'>
                    <div className='row dt-row'>
                      <div className='col-sm-12'>
                        <table id="example" className=" table">
                          <thead>
                            <tr>
                              <th>S.No</th>
                              <th>Domain Name</th>
                              <th>Status</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            {myDomains && myDomains.length > 0 && myDomains.map((data, index) => (
                              <tr key={index}>
                                <td className="pb-20-10">{index + 1}</td>
                                <td>
                                  <div className="d-flex justify-content-start align-items-center user-name">
                                    <div className="d-flex flex-row ">
                                      <span className="emp_name text-truncate">{data.domainName}</span>
                                      {data.isPrimary && (
                                        <span className="bg-success ms-2 px-2 badge">primary</span>
                                      )}
                                    </div>
                                  </div>
                                </td>
                                <td data-th="Status">Active</td>
                                <td data-th="Action">
                                  <a title="Delete" className="cursor-pointer text-danger" onClick={() => deleteDomainHandler(data.id)}>
                                    <IconTrash size={19} className='me-1' />
                                  </a>
                                </td>
                              </tr>
                            ))}
                            {myDomains && myDomains.length == 0 && (
                              <tr>
                                <td colSpan={3} style={{ textAlign: "center", border: "0" }}><h5 style={{ marginTop: "1rem" }}>No Data Available</h5></td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
      {
        showAddDomain && (
          <div>
            <AddDomain
              onClose={closeAddHandler}
            />
          </div>
        )
      }
    </>
  )
}
